// import * as Sentry from '@sentry/react';
import React, {ErrorInfo} from 'react';

interface Props {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<Props> {

	componentDidCatch(error: Error, info: ErrorInfo) {
		const Sentry = (window as any).Sentry;
		if (Sentry) {
			Sentry.captureException(error, {
				extra: {
					componentStack: info.componentStack,
				},
				tags: {
					type: 'react_error',
				},
			});
		}
	}

	render() {
		return this.props.children;
	}
}

export default ErrorBoundary;
